export default __webpack_public_path__ + "static/media/E-WEB-Goal-16.d9da1670.png";